import { render, staticRenderFns } from "./creativeFooterInfos.vue?vue&type=template&id=4a9b8dc8&lang=pug"
import script from "./creativeFooterInfos.vue?vue&type=script&lang=js"
export * from "./creativeFooterInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports